import { useEffect } from "react";
import { useCsConfigurationApi } from "../hooks/useCsConfigurationApi";
import { useUpdateSelectorDefaults } from "../hooks/useUpdateSelectorDefaults";
/**
 * Starts the configuration
 * - requires {@linkcode ConfigurationController}
 *
 * @category Controller
 * @param props
 */
export function ConfigurationStarter(props) {
    const { cfgObjectId, localeId, currencyId, beginLogging, context, state, typeCode, } = props;
    const { startConfiguration } = useCsConfigurationApi();
    const updateSelectorDefaults = useUpdateSelectorDefaults();
    useEffect(() => {
        const controller = new AbortController();
        updateSelectorDefaults();
        startConfiguration({
            cfgObjectId,
            localeId,
            currencyId,
            beginLogging,
            state,
            typeCode,
            context,
        }, { abortSignal: controller.signal });
        return () => {
            controller.abort();
        };
    }, [
        cfgObjectId,
        localeId,
        currencyId,
        beginLogging,
        state,
        context,
        typeCode,
        startConfiguration,
        updateSelectorDefaults,
    ]);
    return null;
}
//# sourceMappingURL=ConfigurationStarter.js.map